import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { apiGet } from '../../../../api/queries/apiGet';
import { API_BASE_URL } from '../constants/consts';
import type { ApiError, QueryFilters } from '../types';
import { AllAuthenticationsTraffic } from '../../types';
import { universalMFAQueryKeys } from '../constants/queryKeys';
import { buildUniversalMfaQueryParams } from '../constants/utils';

const END_POINT = '/metric/allAuthenticationsTraffic';

type AllAuthenticationsTrafficDto = {
    date: string;
    total: number;
    mfa: number;
};

const convertToAllAuthenticationsTraffic = (data: AllAuthenticationsTrafficDto[]): AllAuthenticationsTraffic[] => {
    return data.map((item) => ({
        date: new Date(item.date),
        total: item.total,
        mfa: item.mfa
    }));
};

const fetchAllAuthenticationsTraffic = async (filters: QueryFilters): Promise<AllAuthenticationsTrafficDto[]> => {
    const data = await apiGet<AllAuthenticationsTrafficDto[]>(
        `${API_BASE_URL}${END_POINT}`,
        buildUniversalMfaQueryParams(filters)
    );
    return data;
};

export const useAllAuthenticationsTraffic = (
    filters: QueryFilters
): UseQueryResult<AllAuthenticationsTraffic[], ApiError> => {
    return useQuery({
        queryKey: universalMFAQueryKeys.mfaAllAuthenticationsTraffic(filters),
        queryFn: () => fetchAllAuthenticationsTraffic(filters),
        select: convertToAllAuthenticationsTraffic
    });
};
